export const initialFilters = {
    Overall: 0,
    Scent: 0,
    Sound: 0,
    Staff: 0,
    Visual: 0,
    Texture: 0,
};
export function filterReducer(state, action) {
    switch (action.type) {
        case "Overall":
            return { ...state, Overall: action.payload };
        case "Sound":
            return { ...state, Sound: action.payload };
        case "Scent":
            return { ...state, Scent: action.payload };
        case "Texture":
            return { ...state, Texture: action.payload };
        case "Visual":
            return { ...state, Visual: action.payload };
        case "Staff":
            return { ...state, Staff: action.payload };
        default:
            return state;
    }
}

export const passesFilters = (hotel, filters, requireReview, item, type) => {
    const averageRates = hotel.average_rates || {};
    if (type === 'search' || hotel.source === 'giata') {
        if (requireReview && Object.keys(averageRates).length === 0) return false;
        return Object.entries(filters).every(([key, value]) => value === 0 || averageRates[key] >= value);
    }
    if (type === 'city' && hotel.cityId !== item.id) return false;
    if (type === 'city' && (hotel.cityId !== item.id)) return false;
    if (type === 'state' && (hotel.state !== item.abbreviation)) return false;
    if (requireReview && Object.keys(averageRates).length === 0) return false;
    return Object.entries(filters).every(([key, value]) => value === 0 || averageRates[key] >= value);
    //return value === 0 || hotel.average_rates.find((e) => e.rateCriteriaID === i)?.avgRateCriteria === value
};
